<template>
  <div v-bind:class="{'col-lg-6': !this.subSection}">
    <div class="m-t">
      <div class="bg-muted p-xs b-r-sm document"
           v-bind:class="{ 'document-red': !this.document.canGenerate, 'document-green': this.document.canGenerate }">
        <div class="row">
          <div class="col-lg-6 document-title">
            <label v-if="this.document.canGenerate" class="document-label" style="padding: 0;">{{ document.title }}</label>
            <span v-else>
              {{ document.title }}
              <span v-if="required" class="fa fa-lg fa-exclamation-circle text-warning" title="Document obligatoire"></span>
            </span>
          </div>
          <div class="text-right m-r">
            <div class="tooltip-demo">
              <button
                v-if="this.document.info && this.document.page !== 'partner'"
                v-tooltip.top-center="info[this.document.info]"
                class="btn btn-default btn-circle"
              >
                <i class="fa fa-info-circle"></i>
              </button>
              <button
                v-if="this.document.infoPartner && this.document.page === 'partner'"
                v-tooltip.top-center="infoPartner[this.document.infoPartner]"
                class="btn btn-default btn-circle"
              >
                <i class="fa fa-info-circle"></i>
              </button>
              <template v-if="this.document.base64">
                <button
                  @click="fetchDocument(document.base64)"
                  class="btn btn-default btn-circle"
                  v-tooltip.top-center="'Visualiser'"
                >
                  <i class="fa fa-eye"></i>
                </button>
                <button
                  @click="downloadDocument(document.base64)"
                  class="btn btn-default btn-circle"
                  v-tooltip.top-center="'Télécharger'"
                >
                  <i class="fa fa-download"></i>
                </button>
              </template>
              <template v-else>
                <!--generateCertifCession-->
                <button
                  v-if="this.document.query === 'generateCertifCession' && this.document.page !== 'partner'"
                  class="btn btn-primary btn-sm"
                  style="margin-left: 5px;"
                  v-tooltip.top-center="'Completer les infos du certificat d\'immatriculation'"
                  v-on:click="addCarRegistrationDataModal"
                >
                  <small>Certificat d'immatriculation</small>
                </button>

                <button
                    v-if="this.document.query === 'generatePurchaseOrder' && this.document.page !== 'partner'"
                    class="btn btn-primary btn-sm"
                    style="margin-left: 5px;"
                    v-tooltip.top-center="'Repondez aux questionx avant de générer le document'"
                    v-on:click="purchaseOrderDataModal"
                >
                  <small>Questions</small>
                </button>

                <button
                    v-if="this.document.canGenerate && this.document.query === 'generatePurchaseOrder' && !this.purchaseOrderQuestions.canGenerate"
                    class="btn btn-primary btn-sm"
                    style="margin-left: 5px;background-color: darkgrey"
                    v-tooltip.top-center="'Repondez au questions avant de générer le document'"
                >
                  <small><i class="fa fa-refresh"></i>  Générer</small>
                </button>
                <button
                    v-if="this.document.canGenerate && this.document.query === 'generatePurchaseOrder' && this.purchaseOrderQuestions.canGenerate"
                    class="btn btn-primary btn-sm"
                    style="margin-left: 5px;"
                    v-tooltip.top-center="'Générer le document'"
                    v-on:click="generatePurchaseOrderDocument"
                >
                  <small><i class="fa fa-refresh"></i>  Générer</small>
                </button>

                <span
                  v-if="!this.document.canGenerate && this.document.page !== 'partner'"
                  class="notValid"
                  v-tooltip.top-center="'Le document est indisponible'"
                >
                  <small><i class="fa fa-times"></i>  Indisponible</small>
                </span>
                <button
                  v-if="this.document.canGenerate && this.document.query !== 'generatePurchaseOrder'"
                  class="btn btn-primary btn-sm"
                  style="margin-left: 5px;"
                  v-tooltip.top-center="'Générer le document'"
                  v-on:click="generateDocument"
                >
                  <small><i class="fa fa-refresh"></i>  Générer</small>
                </button>
              </template>
            </div>
          </div>                             
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import gql from 'graphql-tag'

  export default {
    props: {
      document: {
        type: Object,
        required: true
      },
      subSection: {
        type: Boolean
      },
      command: {
          type: Object,
          required: true
      },
      dataForValidationPopup: {
          type: Object
      },
      required: {
          type: Boolean,
          default: false
      }
    },

    data: () => ({
      tempValuesForCarRegistrationDataModal: null,
      info: {},
      infoPartner: {
        generateCertifCession: "Imprimer en 1 exemplaire en recto. Une feuille signée est pour l’acheteur et l’autre feuille signée est pour le vendeur.",
        generateInvoice: "Imprimer en 1 exemplaire à donner au vendeur.",
        generateDisposal: "Imprimer en 2 exemplaires. Une feuille signée est pour l’acheteur et l’autre feuille signée est à envoyer à Carizy.",
        generateExpertiseReport: "À utiliser pour faire le tour du véhicule avec les clients en début de rendez-vous."
      },
      purchaseOrderQuestions: {
        canGenerate: false,
        answerHand: '',
        answerPro: '',
      },
    }),

    computed: {
      documentQueryPurchaseOrder() {
        return gql`
          query {
            ${this.document.query}(orderId: "${this.command.id}", answerHand: "${this.purchaseOrderQuestions.answerHand}", answerPro: "${this.purchaseOrderQuestions.answerPro}") {
              base64
              url
            }
          }
          `;
      },
      documentQuery() {
        return gql`
          query {
            ${this.document.query}(orderId: "${this.command.id}") {
              base64
              url
              extension
            }
          }`;
      },
    },

    methods: {
      async generateDocument () {
        await this.$apollo.query({
          query: this.documentQuery,
          fetchPolicy: 'no-cache'
        }).then(response => {
          this.document.base64 = response.data[this.document.query].url
        }).catch(error => {
          this.showBanner('danger', 'Le document n\'a  pu être généré')
        })
      },
      async generatePurchaseOrderDocument () {
        await this.$apollo.query({
          query: this.documentQueryPurchaseOrder,
          fetchPolicy: 'no-cache'
        }).then(response => {
          this.document.base64 = response.data[this.document.query].url
        }).catch(error => {
          this.showBanner('danger', 'Le document n\'a  pu être généré')
          this.showBanner('danger', error.message)
        })
      },

      async fetchDocument (base64) {
          try {
              this.showFileViewer({
                  image: base64
              })
          } catch (e) {
              this.showBanner('danger', 'Le document associé n\'a  pu être récupéré.')
          }
      },
      async downloadDocument (base64) {
          try {
              this.downloadFileFromBase64(base64);
          } catch (e) {
              this.showBanner('danger', 'Le document associé n\'a  pu être récupéré.');
          }
      },
      getBase64Document (id) {
          const query = gql`
        query {
          showDocument(
          files: {
            fileId: ${id}
          })
          {
            files {
              base64
              id
            }
          }
        }`

          return this.$apollo.query({
              query: query
          })
      },
      async addCarRegistrationDataModal (){
          const document = this.document
          const command = this.command
          const dataForValidationPopup = this.dataForValidationPopup
          const tempValuesForCarRegistrationDataModal = this.tempValuesForCarRegistrationDataModal

          const carRegistrationDocumentId = this.$parent.$parent.beforeSaleDocuments[0].id
          let carRegistrationBase64 = ""

          if(carRegistrationDocumentId){
              const response = await this.getBase64Document(carRegistrationDocumentId)
              carRegistrationBase64 = response.data.showDocument.files[0].base64
          }

          this.showModal({
              childVue: 'add-car-registration-data',
              size: 'modal-lg',
              dataModel: {carRegistrationBase64, document, dataForValidationPopup, command, tempValuesForCarRegistrationDataModal},
          })
      },
      async purchaseOrderDataModal (){

        this.showModal({
          childVue: 'purchase-order-questions',
          size: 'modal-lg',
          dataModel: {
            title: 'Questions d\'usages du véhicule',
          }
        })

        this.$bus.$on('purchase-order-success', (data) => {
          this.purchaseOrderQuestions.answerHand = data.answerHand
          this.purchaseOrderQuestions.answerPro = data.answerPro
          this.purchaseOrderQuestions.canGenerate = true
        })
      },
      async saveCarRegistrationData (data){
          const releaseDateForMutation = moment(data.carRegistrationData.releaseDate, "YYYY-MM-DD").format("DD-MM-YYYY HH:mm:ss")
          const registrationDateForMutation = moment(data.carRegistrationData.registrationDate, "YYYY-MM-DD").format("DD-MM-YYYY HH:mm:ss")

          const result = await this.$apollo.mutate({
              mutation: gql`
                  mutation {
                    updateCarRegistration (
                      carId: "${data.carRegistrationData.carId}",
                      licensePlate: "${data.carRegistrationData.licensePlate}",
                      releaseDate: "${releaseDateForMutation}",
                      lastNameOwner: "${data.carRegistrationData.lastNameOwner}",
                      firstNameOwner: "${data.carRegistrationData.firstNameOwner}",
                      address: "${data.carRegistrationData.address}",
                      city: "${data.carRegistrationData.city}",
                      zipCode: "${data.carRegistrationData.zipCode}",
                      typeVariantVersion: "${data.carRegistrationData.typeVariantVersion}",
                      minesType: "${data.carRegistrationData.minesType}",
                      denomCommercial: "${data.carRegistrationData.denomCommercial}",
                      vehicleIdentification: "${data.carRegistrationData.vehicleIdentification}",
                      nationalGender: "${data.carRegistrationData.nationalGender}",
                      rateCO2: "${data.carRegistrationData.rateCO2}",
                      registrationDate: "${registrationDateForMutation}",
                      formulaNumber: "${data.carRegistrationData.formulaNumber}"
                      ) {
                      result
                    }
                  }`
          })

          this.tempValuesForCarRegistrationDataModal = {
              carId: data.carRegistrationData.carId,
              licensePlate: data.carRegistrationData.licensePlate,
              releaseDate: releaseDateForMutation,
              lastNameOwner: data.carRegistrationData.lastNameOwner,
              firstNameOwner: data.carRegistrationData.firstNameOwner,
              address: data.carRegistrationData.address,
              city: data.carRegistrationData.city,
              zipCode: data.carRegistrationData.zipCode,
              typeVariantVersion: data.carRegistrationData.typeVariantVersion,
              minesType: data.carRegistrationData.minesType,
              denomCommercial: data.carRegistrationData.denomCommercial,
              vehicleIdentification: data.carRegistrationData.vehicleIdentification,
              nationalGender: data.carRegistrationData.nationalGender,
              rateCO2: data.carRegistrationData.rateCO2,
              registrationDate: registrationDateForMutation,
              formulaNumber: data.carRegistrationData.formulaNumber
          }
      }
    },

    mounted () {
      this.$bus.$on('car-registration-data-' + this.document.query, this.saveCarRegistrationData)
    }
  }
</script>

<style>
  button {
    margin-left: 5px;
  }
  .notValid {
    margin-left: 5px;
    font-size: 17px;
    color: red;
    padding-top: 2px;
  }
  .btn-info-doc {
    background: none !important;
    border: none !important;
    box-shadow: none !important;
  }
  .btn-info-doc .fa {
    margin: 0;
    font-size: 16px;
  }
</style>
